import { InvoicesApisActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    error: null,
};

type InvoicesApisActionType = {
    type:
        | InvoicesApisActionTypes.GET_INVOICES_APIS_DATA
        | InvoicesApisActionTypes.INVOICES_API_RESPONSE_SUCCESS
        | InvoicesApisActionTypes.INVOICES_API_RESPONSE_ERROR;
    payload: {
        actionType?: string;
        data: any;
        error: string;
    };
};

const InvoicesApis = (state = INIT_STATE, action: InvoicesApisActionType) => {
    switch (action.type) {
        case InvoicesApisActionTypes.INVOICES_API_RESPONSE_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
            };

        case InvoicesApisActionTypes.INVOICES_API_RESPONSE_ERROR:
            return {
                ...state,
                error: action.payload.error,
            };
        default:
            return { ...state };
    }
};

export default InvoicesApis;
